/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import PropTypes from "prop-types";
import { Box, ListSubheader } from "@mui/material";
import { LoadingSpinner } from "../loading_spinner";

export const DropdownInfiniteLoader = ({
  hasNextPage,
  targetRef,
  isLoading,
}) => {
  if (!hasNextPage) {
    return null;
  }

  return (
    <ListSubheader
      component="div"
      data-testid="dropdown-infinite-loader"
      disableSticky
      ref={hasNextPage ? targetRef : undefined}
      sx={{
        alignItems: "center",
        backgroundColor: "transparent",
        display: "flex",
        justifyContent: "center",
        minHeight: "36px",
        py: 1,
      }}
    >
      {isLoading
        ? <LoadingSpinner isLoading={true} />
        : <Box sx={{ height: 1, width: "100%" }} />}
    </ListSubheader>
  );
};

DropdownInfiniteLoader.propTypes = {
  hasNextPage: PropTypes.bool,
  targetRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  // Shows a spinner while the next page loads.
  isLoading: PropTypes.bool,
};

DropdownInfiniteLoader.defaultProps = {
  hasNextPage: false,
  targetRef: undefined,
  isLoading: false,
};
